


















import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import {PhoneNumber} from "../../modules/models";
import Api from "./Api";
import Phoneinput from "../phoneinput/Phoneinput.vue";

@Component({
    components: {
        "at-phoneinput": Phoneinput
    }
})
export default class AddPhoneDialog extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    get opened() {
        return this.value;
    }
    set opened(v: boolean) {
        this.$emit("input", v);
    }

    phone: PhoneNumber | null = null;

    save() {
        this.$emit("add-phone", this.phone);
        this.opened = false;
    }

    close() {
        this.opened = false;
    }
}
